<template>
  <div v-if="renderComponent">
    <div>
      <h5 class="vue-title pull-left custom-header">
        <strong>{{ $t("ADMIN") }}</strong>
      </h5>
      <p
        class="float-right add-button"
        v-if="checkPermisssion('ADMIN', 'ADMIN_LIST')"
      >
        {{ $t("ADD") }}
        <a href="#/createmanager">
          <em class="fas fa-plus-circle"></em>
        </a>
      </p>
      <b-input-group 
        class="pull-right search-text-box search-box-admin"
      >
        <template v-slot:prepend>
          <b-input-group-text @click="onSerach">
            <em class="fa fa-search"></em>
          </b-input-group-text>
        </template>
        <b-form-input
          size="sm"
          @keyup.enter="onSerach"
          autocomplete="off"
          v-model="searchKeyword"
        ></b-form-input>
      </b-input-group>
    </div>
    <c-table
      :table-data="getAdminList.list"
      :fields="tableHeader"
      :per-page="10"
      striped
      hover
      :total="getAdminList.pageTotal"
      :update="showStatusChangeModal"
      :edit="editTableRow"
      :delete="showDeleteModal"
      :sortTable="sortTable"
      :isBusy="isBusy"
      :pagination="pagination"
      :countPerPage="currentPage"
    ></c-table>
    <nav>
      <div class="pagination-module">
        <b-pagination
          :total-rows="getAdminList.pageTotal"
          @change="pagination"
          :per-page="10"
          v-model="currentPage"
          :prev-text="$t('FORWARD')"
          :next-text="$t('NEXT')"
        />
      </div>
    </nav>

    <b-modal id="modal-delete" hide-footer>
      <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
      <p
        class="my-2 wrapText"
        v-if="selectedItemForDelete.staff_detail != null"
      >
        {{
          selectedItemForDelete.staff_detail.last_name +
            " " +
            selectedItemForDelete.staff_detail.first_name
        }}
        {{ $t("DELETECONFIRMATIONCOMMOM") }}
      </p>
      <p class="my-2" v-else>{{ $t("DELETECONFIRMATIONCOMMOM") }}</p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-danger"
            class="buttons-align-right"
            size="sm"
            @click="deleteSelectedTableRow()"
            >{{ $t("DELETE") }}</b-button
          >
          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="$bvModal.hide('modal-delete')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-Status" hide-footer @hidden="close">
      <template v-slot:modal-title>
        {{ $t("STATUSCHANGECONFIRMATION") }}
      </template>
      <p>ステータスを変更してもよろしいですか？</p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right"
            @click="statusChangeofTableRow()"
            >{{ $t("SUBMIT") }}</b-button
          >

          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="close"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  DELETE_MIG_USER,
  USER_LIST,
  MIG_USER_STATUS_UPDATE
} from "@/store/actions.type";
import cTable from "@/components/Table.vue";
import { checkPermisssion } from "@/shared/utils.js";
export default {
  name: "partnerList",
  data() {
    return {
      searchKeyword: "",
      renderComponent: true,
      selectedItemForDelete: "",
      sortField: "",
      sortDirection: false,
      isBusy: true,
      checkPermisssion: checkPermisssion,
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters(["getAdminList"])
  },
  components: { cTable },
  methods: {
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    showDeleteModal(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-delete");
    },
    /**
     * Edit the table row
     * Input @param {Number} userId Seleted Row id to Edit
     * Output  @param {Number} userId  append to routing Params then Redirect to edit page
     */
    editTableRow(id) {
      this.$router.push({
        name: "editManager",
        params: { id: id.id }
      });
    },
    /**
     * Status function for table Row
     * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
     * Output @param {boolean}   data.status  status of the api call (true or false)
     */
    async statusChangeofTableRow() {
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let selectedItemId = _.get(this.selectedItemForDelete, "id", 0);
      this.$bvModal.hide("modal-Status");

      if (selectedItemId) {
        let status = _.get(this.selectedItemForDelete, "status", "");
        let response = await this.$store.dispatch(MIG_USER_STATUS_UPDATE, {
          id: selectedItemId,
          status: status == "active" ? "inactive" : "active"
        });
        this.isLoading.hide();
        this.pagination(this.currentPage);
        if (_.get(response, "status", false)) {
          this.$toast.success({
            message: _.get(response, "message", "")
          });
        } else {
          this.$toast.error({
            message: _.get(response, "message", "")
          });
        }
      } else {
        this.isLoading.hide();
      }
    },
    /**
     * Show Status Change Modal
     * Input @param {object} row Seleted Row to Change status of it
     * Output PopUp the Status Change Modal
     */
    showStatusChangeModal(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-Status");
    },
    /* Pagintaion */
    pagination(page) {
      this.loadTableData(page);
    },
    /**
     * To load the table data
     * Input @param {page} currentPageCount the page number of data you want
     * Output {object} table data
     */
    async loadTableData(page) {
      this.currentPage = page;
      this.isBusy = true;
      await this.$store.dispatch(USER_LIST, {
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });
      this.isBusy = false;
    },

    /**
     * Delete function for table Row
     * Input @param {Number} userID selected Row ID
     * Output @param {Boolean}   data.status  Boolean status Api call
     */
    async deleteSelectedTableRow() {
      this.$bvModal.hide("modal-delete");
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      let response = await this.$store.dispatch(DELETE_MIG_USER, {
        id: this.selectedItemForDelete.id
      });
      this.isLoading.hide();
      if (_.get(response, "status", false)) {
        this.isBusy = true;
        this.$toast.success({
          message: _.get(response, "message", "")
        });
        if (this.getAdminList.list.length === 1) {
          this.pagination(1);
        } else {
          this.pagination(this.currentPage);
        }
      } else {
        this.$toast.error({
          message: _.get(response, "message", "")
        });
      }
    },
    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    async sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
      await this.$store.dispatch(USER_LIST, {
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });
      this.isBusy = false;
    },
    /*Compomonet Rerendering */
    close() {
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },

    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
      this.pagination(1);
    }
  },
  created() {
    this.$toast.removeAll();
    this.$store
      .dispatch(USER_LIST, { field: "id", sort: "desc" })
      .then(data => {
        this.isBusy = false;
      });
    this.tableHeader = [
      {
        key: "userid",
        label: this.$t("ID"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "staff_detailName",
        label: this.$t("FULLNAME"),
        class: "text-left",
        sortable: true
      },

      {
        key: "role.name",
        label: this.$t("ROLE"),
        class: "text-left",
        sortable: true
      },
      {
        key: "staff_detail.contact_no",
        label: this.$t("MOBILE"),
        class: "text-left",
        sortable: true
      }
    ];

    if (checkPermisssion("ADMIN", "ADMIN_LIST")) {
      // allowing users to do actions on table if they have Permission
      this.tableHeader.push({
        key: "status",
        label: this.$t("STATUS"),
        sortable: false
      });
      this.tableHeader.push({
        key: "actions",
        label: this.$t("ACTION"),
        sortable: false
      });
    } else {
      //Disabled the actions on table if they dont have permission
      this.tableHeader.push({
        key: "status_disable",
        label: this.$t("STATUS"),
        sortable: false
      });
    }
  }
};
</script>

<style>
.add-button{
  font-size: 17px;margin-top: 14px;margin-left:20px;
}
.search-box-admin{
  width:200px;margin:10px 00px;
}
</style>